import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/components/About/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/app/components/Banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/Homework_web_ol/next-bee-website/src/components/Log/index.tsx");
